import React from 'react';
import { Typography, Box } from '@mui/material';
import NetworkHealthCard from './NetworkHealthCard';
import { useTranslation } from 'react-i18next';

interface AssetsConnectedProps {
  count: number;
}

const AssetsConnected: React.FC<AssetsConnectedProps> = ({ count }) => {
  const { t } = useTranslation();
  return (
    <NetworkHealthCard>
      <Typography variant="h6" gutterBottom>
        {t('assets_connected')}
      </Typography>
      <Box
        sx={{
          fontSize: '1.8rem',
          fontWeight: 'bold',
          color: '#4CAF50',
        }}
      >
        {count}
      </Box>
    </NetworkHealthCard>
  );
};

export default AssetsConnected;
